import { FC, ReactNode } from "react";
import { useLocation } from "react-router-dom";

/** Routes that ship their own navigation and footer instead of the HomeCook chrome. */
export const STANDALONE_ROUTES = ["/pawdit", "/compliance"];

type StandaloneRouteGateProps = {
  children: ReactNode;
};

/**
 * Hides shared HomeCook chrome on standalone routes. Rendering it around the navbar and
 * footer keeps the rest of the router untouched, so existing pages behave exactly as before.
 */
export const StandaloneRouteGate: FC<StandaloneRouteGateProps> = ({
  children,
}) => {
  const { pathname } = useLocation();
  const isStandalone = STANDALONE_ROUTES.some(
    (route) => pathname === route || pathname.startsWith(`${route}/`),
  );

  return isStandalone ? null : <>{children}</>;
};

export default StandaloneRouteGate;
